import { ActionReducerMap } from "@ngrx/store";

import { RouterState } from "./src/state";
import { routeReducer } from "./src/store/route.reducer";

export { extractRouteLink } from "./src/route-link/route-link.util";

export { LazyLoadingService } from "./src/lazy-loading/lazy-loading.service";

export { LocalizedRoute, ROUTER_CONFIG, RouteConfig, RouterConfig } from "./src/config/router-config.model";

export { sequentialGuardFactory } from "./src/guard/sequential-guard.guard";
export { sequentialGuardFactoryV2 } from "./src/guard/sequential-guard-v2.guard";
export { CanDeactivateGuard } from "./src/guard/can-deactivate.guard";
export { CanComponentDeactivate } from "./src/guard/guard.model";

export { RouteLinkDirective } from "./src/route-link/route-link.directive";
export { RouteLink, RouteLinkParams } from "./src/route-link/route-link.model";
export { RouteLinkService } from "./src/route-link/route-link.service";

export { RouteLinkActiveDirective } from "./src/route-link-active/route-link-active.directive";
export { RouteLinkActiveOptions } from "./src/route-link-active/route-link-active.model";

export { HistoryService } from "./src/store/history.service";
export { RouteAction } from "./src/store/route.action";
export { RegistrationVersion } from "./src/store/route.const";
export {
	Route,
	RouteState,
	NavigatePayload,
	NavigateByCommandPayload,
	NavigateByUrlPayload,
	NavigationExtras,
	NavigationStartPayload,
	QueryParams,
	ResolveEndPayload,
	SetFragmentPayload,
	SetQueryParamsPayload,
	UpdateRegistrationPayload,
} from "./src/store/route.model";
export { routeReducer } from "./src/store/route.reducer";
export { RouteSelector } from "./src/store/route.selector";
export { RouteService } from "./src/store/route.service";
export { getActivatedRouteSnapshot } from "./src/store/route.util";

export { LowerCaseUrlSerializer } from "./src/url-serialisation/url-serialisation.service";

export { DeepLinkerMock } from "./testing/deep-linker.mock";
export { RouterState } from "./src/state";
export { RouterModule } from "./src/module";
export { LocalizeRouterService } from "./src/localize/localize-router.service";
// todo: remove this re export when consumers consume these resources from @obg/ngx.global.evo
export { HookableRouterModule, HOOKABLE_ROUTES, RouteHook, ROUTE_HOOK } from "@obg/ngx.global.evo";

export { ObgPreloadingStrategy } from "./src/lazy-loading/preloading-strategy";
export const ROUTING_REDUCER: ActionReducerMap<RouterState> = {
	route: routeReducer,
};
